<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewAccount"
        :searchFilters="searchFilters"
        :dropdownOptions="dropdownOptions"
        @handleDynamicOption="handleDynamicOption"
        @searchPage="searchAccounts"
        @resetFilters="resetFilters"
        @removeItem="removeAccount"
        @removeSelectedItems="removeAccounts"
        :addingRight="addingRight"
        :removingRight="removingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="accountsList"
        :actions="actions"
        :idField="idField"
        @handleSelectionChange="handleSelectionChange"
        @handleActionClick="handleActionClick"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
    />
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader"  @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="saveAccount" @handleReset="handleReset"
        />
    </MovableModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

export default{
    name: 'Lead_Accounts',
    components:{
        PageComponent,MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const title = ref('Account Details');
        const addButtonLabel = ref('New Account');
        const addingRight = ref('Adding Lead Accounts');
        const removingRight = ref('Deleting Lead Accounts');
        const rightsModule = ref('CRM');
        const idField = 'crm_account_id';
        const agentID = ref('');
        const agentComponentKey = ref(0);
        const agentArray = computed(() => store.state.Sales_Reps.agentArr);
        const selectedIds = ref([]);
        const depModalVisible = ref(false);
        const accountsList = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const selectedValue = ref(50);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const isEditing = computed(()=> store.state.Lead_Accounts.isEditing)
        const selectedAccount = computed(()=> store.state.Lead_Accounts.selectedAccount);
        const selectedRep = computed(()=> store.state.Lead_Accounts.selectedRep);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Client Name", key: "name"},
            {label: "Email", key: "email"},
            {label: "Phone No", key: "phone_number"},
            {label: "Industry", key: "industry"},
            {label: "Website", key: "website"},
            {label: "Assigned To", key: "assigned_to"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Account', rightName: 'Editing Lead Accounts'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Account', rightName: 'Deleting Lead Accounts'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const customer_name = ref('');
        const email_search = ref('');
        const phone_number_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Search Name...", value: customer_name, width:48},
            {type:'text', placeholder:"Search Phone#...", value: phone_number_search, width:32},
            {type:'text', placeholder:"Search Email...", value: email_search, width:48},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchSalesAgents = async() =>{
            await store.dispatch('Sales_Reps/fetchSalesAgents', {company:companyID.value})
        };
        const handleSelectedAgent = async(option) =>{
            await store.dispatch('Sales_Reps/handleSelectedAgent', option)
            agentID.value = store.state.Sales_Reps.agentID;
            if(selectedAccount.value && selectedRep.value){
                selectedAccount.value.assigned_to.sales_rep_id = agentID.value;
            }
        }
        const clearSelectedAgent = async() =>{
            await store.dispatch('Sales_Reps/updateState', {agentID: ''});
            agentID.value = store.state.Sales_Reps.agentID;
        }
        const agentValue = computed(() => {
           return (selectedAccount.value && selectedAccount.value.assigned_to && !agentID.value) ? selectedAccount.value.assigned_to.sales_rep_id : agentID.value;
        });
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                { type: 'text', name: 'account_name',label: "Account Name", value: selectedAccount.value?.account_name || '', required: true },
                { type: 'text', name: 'email',label: "Email", value: selectedAccount.value?.email || '', required: false },
                { type: 'text', name: 'phone_number',label: "Phone Number", value: selectedAccount.value?.phone_number || '', required: true },
                { type: 'text', name: 'industry',label: "Industry", value: selectedAccount.value?.industry || '', required: true },
                { type: 'text', name: 'website',label: "Website", value: selectedAccount.value?.website || '', required: false },
                {  
                    type:'search-dropdown', label:"Assigned Sales Rep", value: agentValue.value, componentKey: agentComponentKey,
                    selectOptions: agentArray, optionSelected: handleSelectedAgent, required: false,
                    searchPlaceholder: 'Select Rep...', dropdownWidth: '500px', updateValue: selectedRep.value,
                    clearSearch: clearSelectedAgent
                },
            ];
        };
        watch([selectedAccount,selectedRep], () => {
            if(selectedAccount.value && selectedRep.value){
                agentComponentKey.value += 1;
                updateFormFields();
            }else if(selectedAccount.value){
                updateFormFields();
            }
         }, { immediate: true });
        const addNewAccount = async() =>{
            updateFormFields();
            depModalVisible.value = true;
            handleReset();
            await store.dispatch("Lead_Accounts/updateState",{isEditing:false, selectedAccount: null, selectedRep: null})
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const accountID = row[idField];
                let formData = {
                    company: companyID.value,
                    crm_account: accountID
                }
                await store.dispatch('Lead_Accounts/fetchLeadAccount',formData).
                then(()=>{
                    depModalVisible.value = true;
                    flex_basis.value = '1/2';
                    flex_basis_percentage.value = '50';
                })
                
            }else if(action == 'delete'){
                const accountID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    crm_account: accountID
                }
                await store.dispatch('Lead_Accounts/deleteLeadAccount',formData).
                then(()=>{
                    searchAccounts();
                })
            }
        } 
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            agentID.value = '';
            agentComponentKey.value += 1;

        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createLeadAccount = async() =>{
            showModalLoader();
            let formData = {
                account_name: formFields.value[0].value,
                email: formFields.value[1].value,
                phone_number: formFields.value[2].value,
                industry: formFields.value[3].value,
                website: formFields.value[4].value,
                assigned_to: agentID.value,
                assigned_to_id: agentID.value,
                company: companyID.value
            }
            errors.value = [];
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != 'search-dropdown'){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Lead_Accounts/createLeadAccount', formData);
                    if(response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Account created successfully!');
                        handleReset();
                    }else {
                        toast.error('An error occurred while creating the Account.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Account: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchAccounts();
                }
            }

        }
        const updateLeadAccount = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                account_name: formFields.value[0].value,
                email: formFields.value[1].value,
                phone_number: formFields.value[2].value,
                industry: formFields.value[3].value,
                website: formFields.value[4].value,
                assigned_to: agentValue.value,
                assigned_to_id: agentValue.value,
                company: companyID.value,
                crm_account: selectedAccount.value.crm_account_id
            }
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != 'search-dropdown'){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                    toast.error('Fill In Required Fields');
            }else{
                try {
                    const response = await store.dispatch('Lead_Accounts/updateLeadAccount', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        toast.success("Account updated successfully!");
                        handleReset();
                    } else {
                        toast.error('An error occurred while updating the Account.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Account: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchAccounts();
                }
            }
        }
        const saveAccount = () =>{
            if(isEditing.value == true){
                updateLeadAccount();
            }else{
                createLeadAccount();
            }
        }
        const removeAccount = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    crm_account: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Lead_Accounts/deleteLeadAccount',formData)
                    if(response && response.status == 200){
                        toast.success("Account Removed Succesfully");
                        searchAccounts();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Account: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Account") 
            }else{
                toast.error("Please Select An Account To Remove")
            }
        }
        const removeAccounts = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    crm_account: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Lead_Accounts/deleteLeadAccount',formData)
                    if(response && response.status == 200){
                        toast.success("Account(s) Removed Succesfully");
                        searchAccounts();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Account(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select An Account To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchAccounts = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: customer_name.value,
                phone_number: phone_number_search.value,
                email: email_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post(`api/v1/lead-accounts-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                accountsList.value = response.data.results;
                store.commit('Lead_Accounts/LIST_ACCOUNTS', accountsList.value)
                depResults.value = response.data;
                depArrLen.value = accountsList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchAccounts();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchAccounts();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchAccounts();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchAccounts();
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchAccounts(selectedValue.value);
        };
        const dropdownOptions = ref([
            
        ]);
        const handleDynamicOption = async(option) =>{
        
        };
        const resetFilters = () =>{
            email_search.value = '';
            phone_number_search.value = '';
            customer_name.value = '';
            currentPage.value = 1;
            searchAccounts();
        };
        const closeModal = async() =>{
            depModalVisible.value = false;
            handleReset();
        }
        onMounted(()=>{
            searchAccounts();
            fetchSalesAgents();
        })
        return{
            title,idField, searchAccounts, addButtonLabel, searchFilters, resetFilters, tableColumns, accountsList,handleSelectionChange,
            currentPage,depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewAccount,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, saveAccount,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader, removeAccount, removeAccounts,
            addingRight,removingRight,rightsModule, closeModal,selectedValue, selectSearchQuantity,dropdownOptions, handleDynamicOption
        }
    }
}
</script>